import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { authGuard } from '@core/guards/auth.guard';
import { publicGuard } from '@core/guards/public.guard';
import { jobsAccessGuard } from '@core/guards/jobs-access.guard';
import { marketplaceAccessGuard } from '@core/guards/marketplace-access.guard';
import { fleetTeamAccessGuard } from '@core/guards/fleet-team-access.guard';
import { preferredCompaniesAccessGuard } from '@core/guards/preferred-companies-access.guard';
import { workSessionsAccessGuard } from '@core/guards/work-sessions-access.guard';
import { AppPaths } from '@core/routes/app-paths';
import { RoleGuard } from '@features/auth/role.guard';

export const routes: Routes = [
  {
    path: AppPaths.ROOT,
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      // {
      //   path: AppPaths.DASHBOARD,
      //   loadComponent: () =>
      //     import('./features/dashboard/dashboard-page.component').then(
      //       c => c.DashboardPageComponent,
      //     ),
      //   data: { title: 'Dashboard', breadcrumb: 'Dashboard' },
      // },
      {
        path: AppPaths.JOBS,
        canActivate: [jobsAccessGuard],
        data: { breadcrumb: 'Jobs' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/jobs/jobs-shell-page.component').then(
                c => c.JobsShellPageComponent,
              ),
            data: { title: 'Jobs' },
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./features/jobs/job-create/job-create.component').then(
                c => c.JobCreateComponent,
              ),
            data: {
              title: 'Create Job',
              breadcrumb: 'Create Job',
            },
          },
          {
            path: 'edit/:id',
            loadComponent: () =>
              import('./features/jobs/job-create/job-create.component').then(
                c => c.JobCreateComponent,
              ),
            data: {
              title: 'Edit Job',
              breadcrumb: 'Edit Job',
            },
          },
        ],
      },
      {
        path: AppPaths.MARKETPLACE,
        canActivate: [marketplaceAccessGuard],
        data: { title: 'Marketplace', breadcrumb: 'Marketplace' },
        loadComponent: () =>
          import('./features/marketplace/marketplace-page.component').then(
            c => c.MarketplacePageComponent,
          ),
      },
      {
        path: AppPaths.FLEET,
        canActivate: [fleetTeamAccessGuard],
        data: { title: 'Fleet Management', breadcrumb: 'Fleet' },
        loadComponent: () =>
          import('./features/fleet/fleet-page.component').then(c => c.FleetPageComponent),
      },
      {
        path: AppPaths.TEAM,
        canActivate: [fleetTeamAccessGuard],
        data: { title: 'Team Management', breadcrumb: 'Team' },
        loadComponent: () =>
          import('./features/team/team-page.component').then(c => c.TeamPageComponent),
      },
      {
        path: AppPaths.WORK_SESSIONS,
        canActivate: [workSessionsAccessGuard],
        data: { title: 'Work Sessions', breadcrumb: 'Work Sessions' },
        loadComponent: () =>
          import('./features/work-sessions/work-sessions-page.component').then(
            c => c.WorkSessionsPageComponent,
          ),
      },
      {
        path: AppPaths.PREFERRED_COMPANIES,
        canActivate: [preferredCompaniesAccessGuard],
        data: { title: 'Preferred Companies', breadcrumb: 'Preferred Companies' },
        loadComponent: () =>
          import('./features/preferred-companies/preferred-companies-page.component').then(
            c => c.PreferredCompaniesPageComponent,
          ),
      },
      {
        path: `${AppPaths.ADMIN.ROOT}/${AppPaths.ADMIN.COMPANY_MANAGEMENT}`,
        canActivate: [RoleGuard],
        data: { roles: ['admin'], title: 'Company Management', breadcrumb: 'Company Management' },
        loadComponent: () =>
          import('./features/company-management/company-management.component').then(
            c => c.CompanyManagementComponent,
          ),
      },
      {
        path: `${AppPaths.ADMIN.ROOT}/${AppPaths.ADMIN.COMPLIANCE}`,
        canActivate: [RoleGuard],
        data: {
          roles: ['admin'],
          title: 'Compliance',
          breadcrumb: 'Compliance',
        },
        loadComponent: () =>
          import('./features/admin/compliance-dashboard/compliance-dashboard.component').then(
            c => c.ComplianceDashboardComponent,
          ),
      },
      // {
      //   path: AppPaths.BILLING,
      //   data: { roles: ['admin'], title: 'Billing and Payments', breadcrumb: 'Billing' },
      //   loadComponent: () =>
      //     import('./features/billing/billing-page.component').then(c => c.BillingPageComponent),
      // },
      // {
      //   path: AppPaths.REPORTS,
      //   data: { roles: ['admin', 'dispatcher'], title: 'Reports', breadcrumb: 'Reports' },
      //   loadComponent: () =>
      //     import('./features/reports/reports-page.component').then(c => c.ReportsPageComponent),
      // },
      // {
      //   path: AppPaths.ALERTS,
      //   data: { roles: ['admin'], title: 'Alerts and Issues', breadcrumb: 'Alerts' },
      //   loadComponent: () =>
      //     import('./features/alerts/alerts-page.component').then(c => c.AlertsPageComponent),
      // },
      // {
      //   path: `${AppPaths.ADMIN.ROOT}/${AppPaths.ADMIN.DOCUMENT_REVIEW}`,
      //   data: { roles: ['admin'], title: 'Documents Review', breadcrumb: 'Document Review' },
      //   loadComponent: () =>
      //     import('./features/admin/document-review/document-review.component').then(
      //       c => c.AdminDocumentReviewComponent,
      //     ),
      // },
      // {
      //   path: AppPaths.SETTINGS,
      //   data: { title: 'Settings', breadcrumb: 'Settings' },
      //   loadComponent: () =>
      //     import('./features/settings/settings-page.component').then(c => c.SettingsPageComponent),
      // },
      {
        path: AppPaths.PROFILE,
        data: { title: 'User Profile', breadcrumb: 'Profile' },
        loadComponent: () =>
          import('./features/profile/profile-page.component').then(c => c.ProfilePageComponent),
      },
      {
        path: AppPaths.DOCUMENT_VERIFICATION,
        data: {
          title: 'Document Verification',
          breadcrumb: 'Verification',
        },
        loadComponent: () =>
          import('./features/document-verification/document-verification.component').then(
            c => c.DocumentVerificationComponent,
          ),
      },
      // {
      //   path: AppPaths.JOBS_HISTORY,
      //   data: { roles: ['dispatcher'], title: 'Jobs History', breadcrumb: 'History' },
      //   loadComponent: () =>
      //     import('@features/jobs/jobs-history/jobs-history-page.component').then(
      //       c => c.JobsHistoryPageComponent,
      //     ),
      // },
      // {
      //   path: AppPaths.FOREMEN,
      //   data: { roles: ['dispatcher'], title: 'Foremen', breadcrumb: 'Foremen' },
      //   loadComponent: () =>
      //     import('./features/foreman/foreman-page.component').then(c => c.ForemanPageComponent),
      // },
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./features/home/home-redirect-page.component').then(
            c => c.HomeRedirectPageComponent,
          ),
      },
    ],
  },
  {
    path: AppPaths.AUTH.ROOT,
    component: AuthLayoutComponent,
    canActivate: [publicGuard],
    children: [
      {
        path: AppPaths.ROOT,
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
      },
      { path: AppPaths.ROOT, redirectTo: AppPaths.AUTH.LOGIN, pathMatch: 'full' },
    ],
  },
  {
    path: 'setup-account',
    loadComponent: () =>
      import('./features/auth/setup-account/setup-account.component').then(
        c => c.SetupAccountComponent,
      ),
    data: { title: 'Complete Account Setup' },
  },
  {
    path: 'invitations/accept/:token',
    loadComponent: () =>
      import(
        './features/auth/invitation-accept-redirect/invitation-accept-redirect.component'
      ).then(c => c.InvitationAcceptRedirectComponent),
    data: { title: 'Invitation Redirect' },
  },
  {
    path: 'successful-register',
    loadComponent: () =>
      import('./features/auth/successful-register/successful-register.component').then(
        c => c.SuccessfulRegisterComponent,
      ),
    data: { title: 'Registration Successful' },
  },
  {
    path: AppPaths.ONBOARDING,
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/onboarding/onboarding-page.component').then(
        c => c.OnboardingPageComponent,
      ),
    data: { title: 'Complete Your Setup' },
  },
  {
    path: 'mobile-app-redirect',
    loadComponent: () =>
      import('./features/auth/mobile-app-redirect/mobile-app-redirect.component').then(
        c => c.MobileAppRedirectComponent,
      ),
    data: { title: 'Mobile App Required' },
  },
  {
    path: AppPaths.NOT_FOUND,
    loadComponent: () =>
      import('./features/page-not-found/page-not-found.component').then(
        c => c.PageNotFoundComponent,
      ),
  },
  {
    path: 'home',
    redirectTo: 'https://dirtrunner.pro',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: AppPaths.NOT_FOUND },
];
